import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { clientPath } from "@/lib/record-paths";
import type { EntityRef } from "@/types/maxwell";

// Mirror of the canonical resolver in `pilot-domain/src/capabilities/navigate.rs`
// (`resolve_entity_route`) for the deal/customer/contact cases — keep those
// three in lock-step with that table. `agent_run` isn't a read-capability
// entity ref (it comes from the `northstar://agent_run/<uuid>` resource
// scheme instead — see `lib/resource-uri.ts`), but chips of that kind resolve
// the same way: to the Activity tab, focused on the run via `?run=`.
const ROUTE_BY_KIND: Record<EntityRef["kind"], (id: string) => string> = {
  deal: (id) => `/deals/${id}`,
  customer: (id) => clientPath(id),
  // A contact has no standalone page; its ref id is its customer's id.
  contact: (id) => clientPath(id),
  agent_run: (id) => `/maxwell/activity?run=${id}`,
};

/** A clickable citation chip that deep-links to the referenced entity. */
export function EntityLink({ entity }: { entity: EntityRef }) {
  const navigate = useNavigate();
  const to = ROUTE_BY_KIND[entity.kind]?.(entity.id);
  if (!to) return <span className="text-sm text-muted-foreground">{entity.label}</span>;
  return (
    <Button
      variant="ghost"
      size="sm"
      className="h-auto p-0 text-sm text-primary hover:bg-transparent hover:underline"
      onClick={() => navigate(to)}
    >
      {entity.label}
    </Button>
  );
}
